import { Button, Checkbox, Col, DatePicker, Drawer, Form, Grid, Input, Popover, Row, Segmented, Select, Space, Spin, Table, Tag, Typography, message, theme } from "antd";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { CheckSquareOutlined, MoreOutlined, PlusOutlined, PrinterOutlined, SearchOutlined, SettingOutlined, UndoOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import Highlighter from "react-highlight-words";
import "react-phone-input-2/lib/high-res.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { API_BASE_URL } from "../config/serverApiConfig";
import useTranslation from "../customHooks/translations";
import { PatientPagination, clearSearchQuery, incrementTotal, setPSTATUS, setSearchQuery, updateNameColumn } from "../slices/client.slice";
import { tableSize } from "../slices/util.slice";
import DefaultImage from "../styles/1.jpg";
import { normalizeRole } from "./Auth/PermissionType";
import { PATIENT_STATUS, RESERVE_LABEL, isReserveExpired } from "../utils/patientStatus";
import { thumbSrc } from "../utils/imageVariant";
import { nextAppointmentForPatient } from "../utils/surgeryAppointments";
import AppointmentCalendar from "../Components/client/AppointmentCalendar";

const { Title } = Typography;
const { useBreakpoint } = Grid;

function StatChip({ tone, active, label, count, onClick, icon }) {
  return (
    <button type="button" className={`patient-stat-chip is-${tone}${active ? " is-on" : ""}`} onClick={onClick}>
      <span className="patient-stat-copy">
        <span className="patient-stat-count">{count}</span>
        <span className="patient-stat-label">{label}</span>
      </span>
      <span className="patient-stat-icon">{icon}</span>
    </button>
  );
}

function highlightMatch(text, query) {
  const value = text == null ? "" : String(text);
  const q = (query || "").trim();
  if (!q) return value;
  return (
    <Highlighter
      highlightStyle={{
        backgroundColor: "#cdebec",
        color: "#006d77",
        fontWeight: 700,
        padding: "0 1px",
        borderRadius: 3,
      }}
      searchWords={[q]}
      autoEscape
      textToHighlight={value}
    />
  );
}




function ActionsArea({
  columns,
  size2,
  dispatch,
  tableSize,
  handleColumnC,
  handlePrint,
  handelRefresh,
  authSelector,
  setVisible,
}) {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md; // treat < md as mobile

  const [openSheet, setOpenSheet] = React.useState(false);

  const ColumnsPicker = (
    <div style={{ maxHeight: 280, overflow: "auto", paddingInline: 4 }}>
      {columns.slice(1).map((i) => (
        <div key={i.key ?? i.dataIndex} style={{ display: "flex" }}>
          <Space style={{ marginBlock: 6 }}>
            <Checkbox defaultChecked onChange={(e) => handleColumnC(i, e.target.checked)} />
            <span>{i.title}</span>
          </Space>
        </div>
      ))}
    </div>
  );

const modalContentEl = () =>
  document.querySelector(".ant-modal-content") || document.body;

  if (isMobile) {
  return (
    <>
<div style={{ width: "100%",marginTop:10 }}>
  <Button block type="default" className="patient-more-btn" icon={<MoreOutlined />} onClick={() => setOpenSheet(true)}>
    زیاتر
  </Button>
</div>
      <Drawer
        title="هەڵبژاردەکان"
        placement="bottom"
        height="80vh"
        open={openSheet}
        onClose={() => setOpenSheet(false)}
        // IMPORTANT: render into the modal content (full width), not the button's parent
        getContainer={modalContentEl}

        // smooth rounded top, comfy scroll
        styles={{
          body: { padding: 12, maxHeight: "70vh", overflow: "auto" },
          header: { padding: "12px 16px" },
        }}
      >
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          {/* Columns picker */}
          <div>
            <Space style={{ marginBottom: 8 }}>
              <CheckSquareOutlined />
              <b>ستونی خشتە</b>
            </Space>
            <div style={{ maxHeight: 280, overflow: "auto", paddingInline: 4 }}>
              {columns.slice(1).map((i) => (
                <div
                  key={i.key ?? i.dataIndex}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    paddingBlock: 6,
                  }}
                >
                  <Checkbox
                    defaultChecked
                    onChange={(e) => handleColumnC(i, e.target.checked)}
                  />
                  <span style={{ lineHeight: 1.3 }}>{i.title}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Table size */}
          <div>
            <Space style={{ marginBottom: 8 }}>
              <SettingOutlined />
              <b>قەبارەی خشتە</b>
            </Space>
            <Segmented
              block
              value={size2}
              onChange={(e) => dispatch(tableSize(e))}
              options={["small", "middle", "large"]}
            />
          </div>

          {/* Actions */}
          <Space direction="vertical" style={{ width: "100%" }}>
            <Button onClick={handlePrint} icon={<PrinterOutlined />} block>
              چاپکردن
            </Button>
            <Button onClick={handelRefresh} icon={<UndoOutlined />} block>
              نوێکردنەوە
            </Button>
           
          </Space>
        </Space>
      </Drawer>
    </>
  );
}

  // DESKTOP: your original popovers, but keep popups inside the modal DOM
  const getInsideModal = (trigger) =>
    trigger.closest(".ant-modal-content") || document.body;

  return (
    <Space size={5}>
      <Popover
        placement="bottom"
        content={ColumnsPicker}
        trigger="click"
        getPopupContainer={getInsideModal}
        destroyTooltipOnHide
      >
        <Button type="text">
          <CheckSquareOutlined />
        </Button>
      </Popover>

      <Popover
        content={
          <Segmented
            value={size2}
            onChange={(e) => dispatch(tableSize(e))}
            options={["small", "middle", "large"]}
          />
        }
        trigger="click"
        placement="bottom"
        getPopupContainer={getInsideModal}
        destroyTooltipOnHide
      >
        <Button type="text">
          <SettingOutlined />
        </Button>
      </Popover>

      <Button size="middle" onClick={handlePrint} type="text">
        <PrinterOutlined />
      </Button>
      <Button size="middle" onClick={handelRefresh} type="text">
        <UndoOutlined />
      </Button>
     
    </Space>
  );
}

const Patient = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [, setPrintData] = useState([]);
  const [printVisible, setPrintVisible] = useState(false);
  const componentRef = useRef(null);
  const [searchData, setSearchData] = useState([]);
  const translation = useTranslation();
  const authSelector = useSelector((state) => state.auth.auth);
  const isSecretary = normalizeRole(authSelector.role) === "Secretary";
  const themeSelector = useSelector((state) => state.util.theme);
  const [phoneNumber, setPhoneNumber] = useState("");
  const screens = useBreakpoint();

  const [patient, setPatient] = useState([]);

  const { useToken } = theme;
  const { token } = useToken();
  const dispatch = useDispatch();
  const [searchOn, setSearchOn] = useState(false);
  const [appointmentFilter, setAppointmentFilter] = useState(false);
  const [appointments, setAppointments] = useState([]);

  const [rangePickerM] = useState([]);

  const [cards, setCard] = useState({
    arshif: 0,
    active: 0,
    reserve: 0,
  });
  const navigate = useNavigate();
  const appointmentPatients = useMemo(() => {
    const byId = new Map();
    appointments.forEach((item) => {
      if (item.patient?.id && !byId.has(item.patient.id)) {
        byId.set(item.patient.id, item.patient);
      }
    });
    return Array.from(byId.values());
  }, [appointments]);

  const clientRedux = useSelector((state) => state.clients);
  const size2 = useSelector((state) => state.util.size);
  const PSTATUS = useSelector((state) => state.clients.PSTATUS);
  const searchText2 = useSelector((state) => state.clients.searchQuery);

  useEffect(() => {
    if (isSecretary && PSTATUS !== "ALL") {
      dispatch(setPSTATUS("ALL"));
    }
  }, [isSecretary, PSTATUS, dispatch]);

  const [loading, setLoading] = React.useState(false);
  const [liveQuery, setLiveQuery] = useState(searchText2 || "");
  const [searchFetching, setSearchFetching] = useState(false);

  console.log(clientRedux, "🤍🤍🤍🤍🤍");

  const loadCards = useCallback(() => {
    axios.get(`${API_BASE_URL}patient/cards`).then((res) => {
      const reserveCount = res.data.reserve;
      setCard({
        arshif: res.data.archive,
        active: res.data.active,
        reserve: reserveCount ?? 0,
      });
      if (reserveCount == null) {
        axios
          .get(`${API_BASE_URL}patient?status=${PATIENT_STATUS.RESERVE}&size=1&page=0`)
          .then((pageRes) => {
            setCard((prev) => ({ ...prev, reserve: pageRes.data.totalElements || 0 }));
          });
      }
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    async function tts() {
      if (PSTATUS === "ALL") {
        axios.get(`${API_BASE_URL}patient?size=${clientRedux.pagination.pageSize}&page=${clientRedux.pagination.current - 1}`).then((res) => {
          setPatient(res.data.content);

          dispatch(PatientPagination({ ...res.data, sort: "DESC" }));
          console.log(res.data, "😅✅✅✅✅✅ no status");

          setLoading(false);
        });
      } else {
        axios.get(`${API_BASE_URL}patient?status=${PSTATUS}&size=${clientRedux.pagination.pageSize}&page=${clientRedux.pagination.current - 1}`).then((res) => {
          setPatient(res.data.content);
          dispatch(PatientPagination({ ...res.data, sort: "DESC" }));

          console.log(res.data, "😅✅✅✅✅✅ status");
          setLoading(false);
        });
      }

      loadCards();
      axios.get(`${API_BASE_URL}appointment`).then((res) => {
        setAppointments(res.data || []);
      }).catch(() => {
        setAppointments([]);
      });
    }

    tts();
  }, [PSTATUS, dispatch, loadCards]);

  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch2 = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    dispatch(clearSearchQuery());
  };

  console.log(themeSelector);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch2(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch2(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    // onFilter: (value, record) => record.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText2]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handelRefresh = async () => {
    // refresh with PSATTUS
    setLoading(true);
    let sort = clientRedux.order !== undefined ? clientRedux.order : "DESC";

    if (PSTATUS === "ALL") {
      console.log("ALL🤍🤍🤍🤍🤍🤍🤍🤍", clientRedux.order, clientRedux.pagination);

      axios.get(`${API_BASE_URL}patient?size=${clientRedux.pagination.pageSize}&sort=${clientRedux.order}&page=${clientRedux.pagination.current - 1}`).then((res) => {
        setPatient(res.data.content);

        dispatch(PatientPagination({ ...res.data, sort }));

        setLoading(false);
      });
    } else {
      axios.get(`${API_BASE_URL}patient?status=${PSTATUS}&sort=${clientRedux.order}&size=${clientRedux.pagination.pageSize}&page=${clientRedux.pagination.current - 1}`).then((res) => {
        setPatient(res.data.content);

        dispatch(PatientPagination({ ...res.data, sort }));

        setLoading(false);
      });
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforePrint: () => setPrintVisible(true),
    onBeforeGetContent: () => handleOnBeforeGetContent(),
    onAfterPrint: () => setPrintVisible(false),
  });


  const handelDataTableLoad = useCallback(async (pagination, filter, sorter, extra) => {
    setLoading(true);
    let sort = sorter.order !== undefined ? (sorter.order === "ascend" ? "ASC" : "DESC") : "DESC";
    console.log(PSTATUS,"Inside call back");
    if (PSTATUS === "ALL") {
      axios.get(`${API_BASE_URL}patient?size=${pagination.pageSize}&sort=${sort}&page=${pagination.current - 1}`).then((res) => {
        setPatient(res.data.content);

        console.log(res.data, "😅✅✅✅✅✅ no status with sort");

        dispatch(PatientPagination({ ...res.data, sort }));

        setLoading(false);
      });
    } else {
      axios.get(`${API_BASE_URL}patient?status=${PSTATUS}&size=${pagination.pageSize}&page=${pagination.current - 1}`).then((res) => {
        setPatient(res.data.content);

        console.log("hell334o",res.data);

        dispatch(PatientPagination({ ...res.data, sort }));
      });
    }

    setLoading(false);
  }, [PSTATUS, dispatch]);

  const columns = [
    Table.SELECTION_COLUMN,
    {
      title: translation.id,
      dataIndex: "id",
      sorter: true,
      ...getColumnSearchProps("ئایدی"),
      key: "id",
      width: "10%",
      render: (item) => {
        return <p style={{ margin: "auto 0" }}>{highlightMatch(`ID-00${item}`, liveQuery)}</p>;
      },
    },

    {
      dataIndex: "image",
      title: "وێنە",
      width: "6%",
      render: (item) => (
        <div style={{ width: 25, height: 25, margin: "0 5px" }}>
          <img
            alt=""
            src={item ? thumbSrc(item) : DefaultImage}
            width={25}
            height={25}
            loading="lazy"
            decoding="async"
            style={{ width: "100%", height: "100%", borderRadius: 14, display: "block", objectFit: "cover" }}
          />
        </div>
      ),
      key: "8",
    },

    {
      title: "ناوی سیانی",
      dataIndex: "fullName",
      ...getColumnSearchProps("ناوی سیانی"),
      // sorter: true,
      key: "f_name",
      render: (item, record) => {
        return (
          <Space>
            <p style={{ margin: "auto 0", color: "#B22A00" }}>{highlightMatch(item, liveQuery)}</p>
            {isReserveExpired(record.reserveDueDate) && <Tag color="red">بەسەرچوو</Tag>}
          </Space>
        );
      },
    },
    {
      title: "بەرواری کۆتایی",
      dataIndex: "reserveDueDate",
      key: "reserveDueDate",
      render: (item) => {
        if (!item) return <p style={{ margin: "auto 0" }}>—</p>;
        return (
          <p style={{ margin: "auto 0", color: isReserveExpired(item) ? "#781D00" : "#9A7200" }}>
            {dayjs(item).format("YYYY/MM/DD")}
          </p>
        );
      },
    },

    {
      title: "تەمەن",
      dataIndex: "age",
      key: "6",
    },
    {
      title: translation.Phone,
      dataIndex: "phoneNumber",
      key: "6",
      render: (item) => {
        // return p without + i mean 964

        return <p style={{ margin: "auto 0", color: "#CF7900" }}>{highlightMatch(item ? `0${item.slice(4)}` : "", liveQuery)}</p>;
      },
    },

    {
      title: "چاوپێکەوتن",
      key: "appointment",
      render: (_, record) => {
        const next = nextAppointmentForPatient(appointments.filter((item) => item.patient?.id === record.id));
        if (!next) return <p style={{ margin: "auto 0" }}>—</p>;
        return (
          <Button
            type="link"
            style={{ color: "#9A7200", padding: 0, height: "auto" }}
            onClick={(event) => {
              event.stopPropagation();
              navigate(`/Patient/${record.id}?tab=9`);
            }}
          >
            {next.type} {next.date.format("YYYY/MM/DD")}
            {next.time ? ` ${String(next.time).slice(0, 5)}` : ""}
          </Button>
        );
      },
    },
    {
      title: "بەرواری دروست کردن",
      dataIndex: "date",
      key: "date",
      render: (item) => {
        return <p style={{ margin: "auto 0" }}>{dayjs(item).format("YYYY/MM/DD")}</p>;
      },
    },

    {
      title: "کردار",
      dataIndex: "navigate",
      key: "90",
      render: (item, record) => {
        return (
          <Button onClick={() => navigate(`/Patient/${record.id}`)} type="link">
            کردنەوە
          </Button>
        );
      },
    },
  ];

  const onSelectChange = (selectedRowKeys2, data) => {
    if (selectedRowKeys2.length > 1) {
      const lastSelectedRowIndex = [...selectedRowKeys2].pop();
      setSelectedRowKeys(lastSelectedRowIndex);
    }
    setPrintData(data);
    setSelectedRowKeys(selectedRowKeys2);
  };

  const handleOnBeforeGetContent = React.useCallback(() => {
    return new Promise((resolve) => {
      setPrintVisible(true);

      setTimeout(() => {
        resolve();
      }, 2000);
    });
  }, []);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const checkFilter = (e) => {
    if (e.key === "appointment") return true;
    return clientRedux.filterTableTitle.includes(e.title);
  };

  const handleColumnC = (e, check) => {
    if (check) {
      dispatch(updateNameColumn({ data: e.title, type: "add" }));
    } else {
      dispatch(updateNameColumn({ data: e.title, type: "remove" }));
    }
  };

  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [patientForm] = Form.useForm();
  const newPatientStatus = Form.useWatch("status", patientForm);
  const submitPatient = (values) => {
    console.log(values);
    setConfirmLoading(true);

    let phoneNumberWithoutSpace = values.phoneNumber.replace(/\s/g, "");
    let PhoneNumberWithCountryCode = `+964${phoneNumberWithoutSpace.slice(1)}`;
    const reserveDueDate =
      values.status === PATIENT_STATUS.RESERVE && values.reserveDueDate
        ? dayjs(values.reserveDueDate).format("YYYY-MM-DD")
        : null;

    axios
      .post(`${API_BASE_URL}patient`, { ...values, phoneNumber: PhoneNumberWithCountryCode, reserveDueDate })
      .then((res) => {
        message.success("بە سەرکەوتوویی تۆمارکرا");
        setVisible(false);
        setConfirmLoading(false);
        patientForm.resetFields();
        dispatch(incrementTotal());
        console.log(res.data);
        const nextStatus = values.status || PATIENT_STATUS.ACTIVE;
        if (PSTATUS === "ALL" || PSTATUS === nextStatus) {
          setPatient((prev) => [res.data, ...prev]);
        }
        loadCards();
      })
      .catch((err) => {
        if (err.response.status === 515) {
          setConfirmLoading(false);
          return message.error("ئەم ژمارەیە بەکارهێنراوە لە لیستەکە");
        }
        console.log(err);
        message.error("هەڵەیەک هەیە لە زیادکردن");
        setConfirmLoading(false);
      });
  };

  const handleDivClick = (text) => {
    dispatch(setPSTATUS(text));
  };

  const [resultsMax, setResultsMax] = useState(280);
  const searchingMobile = !screens.md && liveQuery.trim().length > 0;

  useEffect(() => {
    const text = liveQuery.trim();
    if (text.length === 0) {
      setSearchOn(false);
      setSearchData([]);
      setSearchFetching(false);
      dispatch(setSearchQuery(""));
      return undefined;
    }

    const controller = new AbortController();
    setSearchOn(true);
    setSearchFetching(true);
    dispatch(setSearchQuery(text));
    const timer = window.setTimeout(() => {
      const url =
        PSTATUS === "ALL"
          ? `${API_BASE_URL}patient/search?limit=50`
          : `${API_BASE_URL}patient/search?status=${PSTATUS}&limit=50`;
      axios
        .post(url, { searchKey: text }, { signal: controller.signal })
        .then((res) => {
          setSearchData(res.data || []);
          setSearchFetching(false);
        })
        .catch((err) => {
          if (err.code === "ERR_CANCELED") return;
          setSearchFetching(false);
        });
    }, text.length === 1 ? 80 : 160);

    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [liveQuery, PSTATUS, dispatch]);

  useEffect(() => {
    if (!searchingMobile) return undefined;
    const place = () => {
      const vv = window.visualViewport;
      const viewH = vv ? vv.height : window.innerHeight;
      setResultsMax(Math.max(160, Math.floor(viewH - 210)));
    };
    place();
    window.visualViewport?.addEventListener("resize", place);
    window.visualViewport?.addEventListener("scroll", place);
    return () => {
      window.visualViewport?.removeEventListener("resize", place);
      window.visualViewport?.removeEventListener("scroll", place);
    };
  }, [searchingMobile]); 

  return (
    <div className="slb2" style={{ position: "relative" }}>
      {/* Liner gradient background div absoulute */}

      <Row justify={"center"} className="com">
        <Col xs={24} sm={24} md={24} lg={24}>
         

         {/*  */}

         {!searchingMobile && !isSecretary && (
          <div className="patient-stat-grid">
            <StatChip
              tone="all"
              active={PSTATUS === "ALL"}
              label={screens.md ? "ژمارەی چارەخواز" : "هەموو"}
              count={clientRedux.pagination.total}
              onClick={() => handleDivClick("ALL")}
              icon={
                <svg width="16" height="16" viewBox="0 0 639 672" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M308.017 3.59347L498.697 113.681L292.271 320.121L201.953 229.804C182.724 210.58 154.703 203.069 128.437 210.107C102.172 217.143 81.656 237.659 74.62 263.919C67.5836 290.184 75.0887 318.205 94.3173 337.435L238.464 481.581C252.735 495.847 272.089 503.863 292.271 503.863C312.453 503.863 331.812 495.847 346.083 481.576L589.163 238.483V490.549C589.163 495.273 587.923 499.909 585.564 503.997C583.204 508.086 579.809 511.482 575.72 513.841L308.027 668.388C303.938 670.747 299.303 671.992 294.584 671.992C289.86 671.992 285.225 670.747 281.136 668.388L13.4427 513.841C9.35933 511.482 5.96347 508.086 3.60414 503.997C1.2396 499.909 0 495.273 0 490.549V181.443C0 171.833 5.12507 162.953 13.4427 158.151L281.136 3.60413C285.225 1.2448 289.86 0 294.584 0C299.303 0 303.938 1.24479 308.027 3.60413L308.017 3.59347ZM178.023 253.713C167.34 243.031 151.772 238.859 137.184 242.771C122.591 246.682 111.195 258.077 107.283 272.667C103.376 287.26 107.548 302.828 118.225 313.511L262.372 457.644C270.299 465.571 281.055 470.024 292.268 470.024C303.481 470.024 314.237 465.571 322.164 457.639L626.231 153.572C636.897 142.89 641.059 127.327 637.147 112.744C633.236 98.1603 621.845 86.7709 607.262 82.8589C592.679 78.9469 577.117 83.1089 566.434 93.7808L292.261 367.954L178.023 253.713Z" fill="currentColor"/>
                </svg>
              }
            />
            <StatChip
              tone="active"
              active={PSTATUS === "true"}
              label="چالاک"
              count={cards.active}
              onClick={() => handleDivClick("true")}
              icon={
                <svg width="16" height="16" viewBox="0 0 665 665" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M507.72 332.265C507.72 429.167 429.163 507.719 332.267 507.719C235.371 507.719 156.813 429.161 156.813 332.265C156.813 235.369 235.371 156.812 332.267 156.812C429.163 156.812 507.72 235.369 507.72 332.265Z" fill="currentColor"/>
                  <path d="M332.267 0C148.773 0 0 148.76 0 332.267C0 515.773 148.76 664.533 332.267 664.533C515.773 664.533 664.533 515.773 664.533 332.267C664.533 148.773 515.773 0 332.267 0ZM332.267 582.4C194.12 582.4 82.1333 470.405 82.1333 332.267C82.1333 194.128 194.128 82.1333 332.267 82.1333C470.405 82.1333 582.4 194.128 582.4 332.267C582.4 470.405 470.405 582.4 332.267 582.4Z" fill="currentColor"/>
                </svg>
              }
            />
            <StatChip
              tone="reserve"
              active={PSTATUS === PATIENT_STATUS.RESERVE}
              label={RESERVE_LABEL}
              count={cards.reserve}
              onClick={() => handleDivClick(PATIENT_STATUS.RESERVE)}
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.2 1.2.4 2.5.6 3.8.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.6.6 3.8.1.4 0 .8-.3 1.1L6.6 10.8Z" fill="currentColor"/>
                </svg>
              }
            />
            <StatChip
              tone="block"
              active={PSTATUS === "false"}
              label="بلاک لیست"
              count={cards.arshif}
              onClick={() => handleDivClick("false")}
              icon={
                <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5 8.50001L8.5 13.5M8.5 8.50001L13.5 13.5M6 2.33801C7.51945 1.45874 9.24448 0.997119 11 1.00001C16.523 1.00001 21 5.47701 21 11C21 16.523 16.523 21 11 21C5.477 21 1 16.523 1 11C1 9.17901 1.487 7.47001 2.338 6.00001" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              }
            />
          </div>
         )}


          <div className="patient-toolbar">
              <Title
                id="prime-color"
                style={{
                  color:
                    PSTATUS === "ALL"
                      ? token.colorPrimary
                      : PSTATUS === PATIENT_STATUS.ACTIVE
                      ? "#006E78"
                      : PSTATUS === PATIENT_STATUS.RESERVE
                      ? "#9A7200"
                      : "#781D00",
                  fontWeight: "bold",
                  margin: 0,
                }}
                level={screens.md ? 3 : 4}
              >
                {PSTATUS === "ALL"
                  ? "چارەخوازەکان"
                  : PSTATUS === PATIENT_STATUS.ACTIVE
                  ? screens.md ? "چارەخوازی چالاک" : "چالاک"
                  : PSTATUS === PATIENT_STATUS.RESERVE
                  ? screens.md ? `چارەخوازی ${RESERVE_LABEL}` : "جێگرەوە"
                  : screens.md ? "چارەخوازی بلاک لیست" : "بلاک لیست"}
              </Title>

              <Input
                value={liveQuery}
                suffix={searchFetching ? <Spin size="small" /> : <SearchOutlined className="site-form-item-icon " />}
                size={screens.md ? "large" : "middle"}
                onChange={(e) => setLiveQuery(e.target.value)}
                bordered={false}
                allowClear
                className="patient-search-field"
                style={{ width: "100%", fontSize: 16 }}
                placeholder={translation.Search}
              />

              <div className="patient-toolbar-end">
              <div className="patient-toolbar-btns">
               {(authSelector.role === "admin" || authSelector.role === "Secretary") && (
        <Button className="patient-toolbar-btn" onClick={() => setVisible(true)} type="default">
          <PlusOutlined /> {screens.md ? "چارەخوازی نوێ" : "نوێ"}
        </Button>
      )}
              <Button
                className={`patient-toolbar-btn is-apt${appointmentFilter ? " is-apt-on" : ""}`}
                type={appointmentFilter ? "primary" : "default"}
                onClick={() => setAppointmentFilter((prev) => !prev)}
              >
                چاوپێکەوتن {appointments.length}
              </Button>
              </div>

            {searchingMobile && (
                <div className="patient-live-results" style={{ maxHeight: resultsMax }}>
                  {searchFetching && searchData.length === 0 ? (
                    <div className="patient-live-empty">
                      <Spin />
                    </div>
                  ) : searchData.length === 0 ? (
                    <div className="patient-live-empty">هیچ چارەخوازێک نییە</div>
                  ) : (
                    searchData.map((item) => (
                      <button
                        key={item.id}
                        type="button"
                        className="patient-live-row"
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={() => navigate(`/Patient/${item.id}`)}
                      >
                        <img
                          alt=""
                          src={item.image ? thumbSrc(item.image) : DefaultImage}
                          className="patient-live-photo"
                        />
                        <span className="patient-live-meta">
                          <strong>{highlightMatch(item.fullName, liveQuery)}</strong>
                          <small>
                            {highlightMatch(item.phoneNumber ? `0${item.phoneNumber.slice(4)}` : "", liveQuery)}
                            {item.id != null ? ` · ID-00${item.id}` : ""}
                          </small>
                        </span>
                      </button>
                    ))
                  )}
                </div>
            )}

    {!searchingMobile && (
      <ActionsArea
    columns={columns}
    size2={size2}
    dispatch={dispatch}
    tableSize={tableSize}
    handleColumnC={handleColumnC}
    handlePrint={handlePrint}
    handelRefresh={handelRefresh}
    authSelector={authSelector}
    setVisible={setVisible}
  />
            )}
              </div>
          </div>

          {!searchingMobile && appointmentFilter ? (
            <AppointmentCalendar
              appointments={appointments}
              query={liveQuery}
              onOpen={(id) => navigate(`/Patient/${id}?tab=9`)}
            />
          ) : null}

          {!searchingMobile && !appointmentFilter && <Row style={{ marginTop: 10, backgroundColor: token.colorBgContainer, borderRadius: token.borderRadius, boxShadow: token.boxShadow, padding: token.padding }} justify={"space-between"}>
            <Col xs={24}>
              <Table
                size={size2}
                style={{ marginTop: screens.md ? 10 : 0 }}
                rowClassName={(record, index) => (index % 2 === 0 ? (themeSelector === "dark" ? "table-row-dark2" : "table-row-dark") : themeSelector === "dark" ? "table-row-light2" : "table-row-light")}
                scroll={{
                  x: 1000,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      navigate(`/Patient/${record.id}`);
                    },
                  };
                }}
                ref={componentRef}
                pagination={appointmentFilter || searchOn || printVisible ? false : clientRedux.pagination}
                columns={columns.filter(checkFilter)}
                loading={liveQuery.trim() ? searchFetching : loading}
                dataSource={appointmentFilter ? appointmentPatients : searchOn ? searchData : patient}
                rowKey={(item) => item.id}
                onChange={handelDataTableLoad}
                rowSelection={rowSelection}
              />
            </Col>
          </Row>}
        </Col>
      </Row>

    <Drawer
  title={<Title style={{ color: "#59114d", margin: 0 }} level={5}>زیاد کردنی چارەخواز</Title>}
  open={visible}
  onClose={() => setVisible(false)}
  placement={screens.md ? "right" : "bottom"}
  width={screens.md ? 520 : "100%"}
  height={screens.md ? undefined :" 80vh"}
  destroyOnClose
  maskClosable
  // keep the content usable on small screens
  styles={{
    body: { padding: token.padding, maxHeight: "70vh", overflow: "auto" },
    header: { padding: "12px 16px" },
    footer: { padding: "12px 16px" },
  }}
 
>
  <Form.Provider
    onFormFinish={(name, { values }) => {
      if (name === "AWS") submitPatient(values);
    }}
  >
    <Form name="AWS" form={patientForm} layout={screens.md ? "horizontal" : "vertical"}>
      <Form.Item
        style={{ marginBottom: 8, marginTop: 0 }}
        label={"ناوی سیانی"}
        labelCol={screens.md ? { span: 5 } : undefined}
        name={"fullName"}
        rules={[{ required: true, message: "ناو پێویستە" }]}
      >
        <Input size="large" placeholder={"ناوی سیانی"} />
      </Form.Item>

      <Form.Item
        style={{ marginBottom: 8, marginTop: 0 }}
        label="ژم. مۆبایل"
        labelCol={screens.md ? { span: 5 } : undefined}
        name={"phoneNumber"}
        rules={[
          { required: true, message: "ژمارەی مۆبایل پێویستە" },
          { pattern: /^0\d{10}$/, message: "ژمارە هەڵەیە (نمونە: 07xxxxxxxxx)" },
        ]}
      >
        <Input
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="tel"
          size="large"
          maxLength={11}
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ""))}
          onPaste={(e) => {
            const t = e.clipboardData.getData("text");
            if (/\D/.test(t)) e.preventDefault();
          }}
          placeholder="ژم. مۆبایل"
        />
      </Form.Item>

      <Form.Item
        style={{ marginBottom: 8, marginTop: 0 }}
        label={"تەمەن"}
        labelCol={screens.md ? { span: 5 } : undefined}
        name={"age"}
      >
        <Input
           type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="tel"
         
          maxLength={11}
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ""))}
          onPaste={(e) => {
            const t = e.clipboardData.getData("text");
            if (/\D/.test(t)) e.preventDefault();
          }}
        
        size="large" placeholder={"تەمەن"} />
      </Form.Item>

      <Form.Item
        style={{ marginBottom: 8, marginTop: 0 }}
        label={"بار"}
        initialValue={PATIENT_STATUS.ACTIVE}
        labelCol={screens.md ? { span: 5 } : undefined}
        name={"status"}
      >
        <Select size="large">
          <Select.Option value={PATIENT_STATUS.ACTIVE}>چالاک</Select.Option>
          <Select.Option value={PATIENT_STATUS.RESERVE}>{RESERVE_LABEL}</Select.Option>
          <Select.Option value={PATIENT_STATUS.BLOCK}>بلاک لیست</Select.Option>
        </Select>
      </Form.Item>

      {newPatientStatus === PATIENT_STATUS.RESERVE && (
        <Form.Item
          style={{ marginBottom: 8, marginTop: 0 }}
          label={"بەرواری کۆتایی"}
          labelCol={screens.md ? { span: 5 } : undefined}
          name={"reserveDueDate"}
        >
          <DatePicker
            size="large"
            allowClear
            inputReadOnly
            placeholder="ئارەزوومەندانە"
            style={{ width: "100%" }}
          />
        </Form.Item>
      )}

      <Form.Item
        style={{ marginBottom: 8, marginTop: 0 }}
        label={"بەروار"}
        initialValue={dayjs()}
        labelCol={screens.md ? { span: 5 } : undefined}
        name={"date"}
      >
        <DatePicker size="large"

        
        inputReadOnly placeholder={"بەروار"} style={{ width: "100%" }} />
      </Form.Item>

       <Space style={{ width: "100%", justifyContent: "space-between",marginTop:20 }}>
      <Button onClick={() => setVisible(false)}>
        پاشگەزبوونەرە
      </Button>
      <Button type="primary" loading={confirmLoading} onClick={() => patientForm.submit()}>
        زیادکردن
      </Button>
    </Space>
    </Form>
  </Form.Provider>
</Drawer>
    </div>
  );
};

export default Patient;
